import React from 'react';
import { AnyObject } from 'final-form';
import { createFormField } from 'Shared/utils/createFormField';
import StyledCheckbox from 'Shared/components/Checkboxes/StyledCheckbox/StyledCheckbox';
import { isConsumerDomain } from 'Shared/helpers';

// Hooks
import useValidateEmployeeEmail from 'Shared/utils/hooks/use-validate-employee-email';

import './index.scss';

function EmailCheckbox({ value, onChange }: AnyObject) {
  const { isEmployeeEmailOrValidDomain } = useValidateEmployeeEmail();

  if (!value) return null;

  const handleChange = () => onChange({ ...value, selected: !value.selected });
  const notWorkEmail = isConsumerDomain(value.email);
  const invalidPiDomain = !isEmployeeEmailOrValidDomain({
    email: value.email,
  });

  if (notWorkEmail && !value.disabled) onChange({ ...value, selected: false, disabled: true });
  if (invalidPiDomain && !value.disabled) onChange({ ...value, selected: false, disabled: true });

  return (
    <div className="EmailCheckbox d-flex justify-content-between mb-3 flex-wrap">
      <StyledCheckbox
        id={`checkbox-${value.email}`}
        checked={value.selected}
        label={value.email}
        active={!value.disabled}
        labelClassName="EmailCheckbox__label cursor-pointer mr-3"
        onChange={handleChange}
      />
      {value.alreadyOnWP && !notWorkEmail && <div className="EmailCheckbox__info">Already on PI Perform</div>}
      {notWorkEmail && <div className="EmailCheckbox__error">Not a work email</div>}
      {invalidPiDomain && <div className="EmailCheckbox__error">Email must be part of PI allowed domains</div>}
    </div>
  );
}

export default createFormField(EmailCheckbox);
